module.exports = __webpack_public_path__ + "img/hgwa.01729237.svg";